import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-hot-toast';
import { postApi } from '../../ApiServices/api';
import { apiEndPoints } from '../../ApiServices/config';
import {
  serviceOutsideUpdateCart,
  serviceOutsideAddToCart,
  serviceOutsideClearCart,
  serviceOutsideRemoveFromCart
} from '../../actions/index';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { UserContext } from '../../context/UserContext';
import { useContext } from 'react';
dayjs.extend(utc);

export const useServicesOutsideCart = () => {
  const { user } = useContext(UserContext);
  const [totalAmount, setTotalAmount] = useState(0);
  const [expanded, setExpanded] = useState({});
  const [selectedDate, setSelectedDate] = useState({});
  const [locations, setLocations] = useState({});
  const [priestsOutisde, setPriestsOutisde] = useState({});
  const [caterings, setCaterings] = useState({});
  const isDevoteeLoggedIn = !!localStorage.getItem('token');
  const cartArr = useSelector((state) => state.servicesOutsideTheTemple);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { control } = useForm({});
  const bookingType = JSON.parse(localStorage.getItem('temple_config'))?.data?.service_outside_temple_flow;
  const serivceType = 'servicesOutsideTemple';

  const validateItem = async (itemType, item) => {
    if (item.booking_config === 'Online booking not available call temple to book') {
      const response = await postApi(apiEndPoints.getBookingConfigByTitle, {
        title: item.booking_config
      });
      toast.error(response.data.data.data.message);
      return false;
    } else if (item.amount == 0) {
      toast.error("You can't book this puja. For more information, please contact the temple.");
      return false;
    } else if (!selectedDate[item._id]) {
      toast.error('Please select a date for the Puja.');
      return false;
    } else {
      return true;
    }
  };

  const addItem = async (itemType, item) => {
    if (selectedDate[item._id]) {
      const existingCartItem = cartArr.find((cartItem) => cartItem._id === item._id && cartItem.selectedDate === selectedDate[item._id]);

      if (existingCartItem) {
        const updatedItem = {
          ...existingCartItem,
          type_id: 1,
          quantity: 1,
          location: locations[item._id] ? locations[item._id] : '',
          catering: caterings[item?._id] ? true : false,
          priest: priestsOutisde[item._id] ? priestsOutisde[item._id] : '',
          selectedDate: selectedDate[item._id]
        };
        dispatch(serviceOutsideUpdateCart(updatedItem));
        toast.success('Your puja/donation has been successfully updated.');
      } else {
        const newItem = {
          ...item,
          type_id: 1,
          quantity: 1,
          itemType: itemType,
          location: locations[item._id] ? locations[item._id] : '',
          priest: priestsOutisde[item._id] ? priestsOutisde[item._id] : '',
          catering: caterings[item?._id] ? true : false,
          selectedDate: selectedDate[item?._id]
        };

        dispatch(serviceOutsideAddToCart(newItem));
        toast.success('Your puja/donation has been successfully added to the puja basket.');
      }
    }
  };

  const handleChildrenRemove = (item) => {
    dispatch(
      serviceOutsideRemoveFromCart({
        _id: item._id,
        selectedDate: item.selectedDate
      })
    );
    toast.success('Item removed from the Basket');
  };

  const handleEmptyPoojaBasket = () => {
    dispatch(serviceOutsideClearCart());
  };

  const handleCheckout = () => {
    if (cartArr.length === 0) {
      toast.error('Puja basket is empty, add services/donations before payment');
    } else {
      if (isDevoteeLoggedIn) {
        navigate(`/${serivceType}/${bookingType}`);
      } else {
        toast.error('Need to login for checkout');
      }
    }
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded((prev) => ({
      ...prev,
      [panel]: newExpanded ? panel : false
    }));
  };

  const serviceOutisdeRequest = async () => {
    const payload = {
      lineItems: cartArr?.map((item) => ({
        _id: item._id,
        name: item.title,
        quantity: item.quantity || 1,
        price: item.amount,
        date: item.selectedDate,
        location: item.location,
        address: item?.address,
        city: item.location === '2' ? item?.city : null,
        state: item.location === '2' ? item?.state : null,
        country: item.location === '2' ? item?.country : null,
        zipcode: item.location === '2' ? item?.zipcode : null,
        addressDetails: item?.addressDetails,
        catering: item?.catering,
        rental: item?.rentals
      })),
      totalAmount,
      payoutDetails: user,
      source: 1
    };

    if (isDevoteeLoggedIn) {
      payload.userId = user?.user_id;
    }

    const response = await postApi(apiEndPoints.makeOutsideRequest, payload);
    if (response?.data?.status === 1) {
      toast.success('Request Sent Successfully');
    } else {
      toast.error('Something Went Wrong');
    }
    dispatch(serviceOutsideClearCart());
  };
  return {
    control,
    addItem,
    validateItem,
    selectedDate,
    setSelectedDate,
    cartArr,
    totalAmount,
    setTotalAmount,
    expanded,
    setExpanded,
    handleChildrenRemove,
    handleEmptyPoojaBasket,
    handleCheckout,
    handleChange,
    locations,
    setLocations,
    priestsOutisde,
    setPriestsOutisde,
    caterings,
    setCaterings,
    serviceOutisdeRequest,
    bookingType
  };
};
